import toastMaster from '../../services/toastMaster';
export default function closeComponents() {
  toastMaster.dismissCurrentToast();

  // slide out keyboard from series gallery
  document.body.style.transform = 'none';
}
